import { Autocomplete, styled, TextField } from "@mui/material";

const DropDown = styled(Autocomplete)(({ theme }) => ({
  width: theme.spacing(25),
}));

const TextInput = styled(TextField)(({ theme }) => ({
  width: theme.spacing(30),
}));

export { DropDown, TextInput };
